/**
 * SORGU ANAHTARI FABRIKASI — organizasyon.
 *
 * NEDEN FABRIKA: bir mutasyonun yanlis anahtari (ya da hic anahtar)
 * gecersiz kilmasi, "kaydettim ama listede yok" sinifindan hatalarin tek
 * sebebi. Anahtarlar elle yazildiginda `['members']` ile `['member']` arasindaki
 * fark derleme zamaninda gorunmez; buradan uretildiklerinde gorunur.
 *
 * GECERSIZ KILMA HARITASI (mutasyon -> tazelenmesi gereken sorgular):
 *
 *   updateOrganization        -> me()
 *   changeMemberType          -> members(), memberPermissions(memberId), me()
 *                                (me: uyeler sayfasindaki rozet ve memberCount)
 *   removeMember              -> members(), me()
 *   replaceMemberPermissions  -> memberPermissions(memberId), members()
 *                                (members: satirdaki "n yetki tanimli" sayaci)
 *   createMember              -> members(), me()
 *   HERHANGI BIR uye/yetki islemi -> auditLog.all() (sunucu her birine kayit yazar)
 *
 * `all` ile baslayan hiyerarsi bilincli: `invalidateQueries({ queryKey:
 * organizationKeys.all })` tek satirda hepsini tazeler ve yeni bir sorgu
 * eklendiginde unutulmaz.
 */
export const organizationKeys = {
  all: ['organization'] as const,

  /** GET /v1/organizations/me — profil + cagiranin uyeligi. */
  me: () => [...organizationKeys.all, 'me'] as const,

  /** GET /v1/organizations/me/members */
  members: () => [...organizationKeys.all, 'members'] as const,

  /** GET /v1/permissions — VERILEBILIR kodlarin katalogu (kendi yetkilerin degil). */
  permissionCatalogue: () => [...organizationKeys.all, 'permission-catalogue'] as const,

  /** Tum uye-yetki sorgulari — tek uye bilinmiyorsa bu koke gecersiz kilinir. */
  memberPermissionsRoot: () => [...organizationKeys.all, 'member-permissions'] as const,

  /** GET /v1/organizations/me/members/permissions?memberId= */
  memberPermissions: (memberId: string) =>
    [...organizationKeys.memberPermissionsRoot(), memberId] as const,

  /** Tum denetim kaydi sorgulari (filtre farketmeksizin). */
  auditLogRoot: () => [...organizationKeys.all, 'audit-log'] as const,

  /** GET /v1/organizations/me/audit-log — filtre anahtarin PARCASI. */
  auditLog: (actionCode: string | null) =>
    [...organizationKeys.auditLogRoot(), actionCode ?? 'all'] as const,
};
